import { animated, useTransition } from 'react-spring';
import {
  getAdminPanelsHistoryLastAction,
  getCurrentAdminPanelsHistoryEntry,
} from '../../../selectors';
import { AdminPanelControllerProps } from './admin-panel-controller-props';
import { AdminPanelName } from '../../../state';
import { HistoryStackLastAction } from '../../../state';
import React from 'react';
import { getPanel } from './get-panel';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const AnimatedDiv = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

const Animation = animated(AnimatedDiv);

const getFrom = (lastAction: HistoryStackLastAction | null): string =>
  lastAction === HistoryStackLastAction.Pop
    ? 'translate3d(-50%,0,0)'
    : 'translate3d(100%,0,0)';

const getLeave = (lastAction: HistoryStackLastAction | null): string =>
  lastAction === HistoryStackLastAction.Pop
    ? 'translate3d(100%,0,0)'
    : 'translate3d(-50%,0,0)';

export const AdminPanelController: React.FunctionComponent<
  AdminPanelControllerProps
> = (props): React.ReactElement => {
  const currentEntry = useSelector(getCurrentAdminPanelsHistoryEntry);
  const lastAction = useSelector(getAdminPanelsHistoryLastAction);

  const from = getFrom(lastAction);
  const leave = getLeave(lastAction);

  const transitions = useTransition(
    currentEntry,
    entry => (entry ? entry.key : ''),
    {
      config: { friction: 36, tension: 450 },
      enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
      from: { opacity: 0, transform: from },
      initial: { opacity: 1, transform: 'translate3d(0%,0,0)' },
      leave: { opacity: 0, transform: leave },
    },
  );

  return (
    <React.Fragment>
      {transitions.map(
        ({ item, props, key }): React.ReactElement => {
          const panel = getPanel(item);
          return (
            <Animation style={props} key={key}>
              {panel}
            </Animation>
          );
        },
      )}
    </React.Fragment>
  );
};

AdminPanelController.displayName = 'AdminPanelController';
